import React from 'react';
import SelectProgrammingLanguage from './SelectProgrammingLanguage'
import PersonalDataSection from './sections/PersonalDataSection';
import OverviewSection from './sections/OverviewSection';
import AuthenticationSection from './sections/AuthenticationSection';
import ErrorsSection from './sections/ErrorsSection';
import SocialSecurityNumberSection from './sections/personal/SocialSecurityNumberSection';
import NameSection from './sections/personal/NameSection';
import PhoneSection from './sections/personal/PhoneSection';
import PaginationSection from './sections/PaginationSection';
import BusinessDataSection from './sections/BusinessDataSection';
import BusinessIdSection from './sections/business/BusinessIdSection';

const Main = () => {
  return (
    <main role="main" className="ml-lg-auto col-lg-10 main-column">
      <SelectProgrammingLanguage />
      <OverviewSection />
      <AuthenticationSection />
      <PaginationSection />
      <ErrorsSection />
      <PersonalDataSection />
      <SocialSecurityNumberSection />
      <NameSection />
      <PhoneSection />
      <BusinessDataSection />
      <BusinessIdSection />
    </main>
  );
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js